import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { ModuleCompletionChart } from './charts/ModuleCompletionChart'
import { CollectedPointsChart } from './charts/CollectedPointsChart'
import { SelectedVoucherValueChart } from './charts/SelectedVoucherValueChart'
import { DashboardDateFilterBar } from './components/DashboardDateFilterBar'
import { TotalEmployeesCard } from './statistics/TotalEmployeesCard'
import { ActivatedAccountsCard } from './statistics/ActivatedAccountsCard'
import { AppUsageCard } from './statistics/AppUsageCard'
import { ActiveModulesCard } from './statistics/ActiveModulesCard'
import { TopPointsCard } from './statistics/TopPointsCard'
import { TopActionsCard } from './statistics/TopActionsCard'
import { defaultDashboardDateFilter, validateDashboardDateFilter } from './dateFilter'

export default function DashboardPage() {
  const { t } = useTranslation('dashboard')
  // One date filter for all charts below the bar
  const [dateFilter, setDateFilter] = useState(() => defaultDashboardDateFilter())
  const dateFilterError = validateDashboardDateFilter(dateFilter)

  return (
    <PageLayout scrollEnabled>
      <PageHeader title={t('header.title')} description={t('header.description')} />
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <TotalEmployeesCard />
          <ActivatedAccountsCard />
          <AppUsageCard />
          <ActiveModulesCard />
          <TopPointsCard />
          <TopActionsCard />
        </div>

        <DashboardDateFilterBar value={dateFilter} error={dateFilterError} onChange={setDateFilter} />

        <ModuleCompletionChart filter={dateFilter} isFilterValid={dateFilterError == null} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CollectedPointsChart filter={dateFilter} isFilterValid={dateFilterError == null} />
          <SelectedVoucherValueChart filter={dateFilter} isFilterValid={dateFilterError == null} />
        </div>
      </div>
    </PageLayout>
  )
}
